import React from 'react'

import BaseComponent from 'utils/BaseComponent'

import VehicleData from './VehicleData'
import Documents from './Documents'


export default class Data extends BaseComponent {

  render() {
    return (
      <div className="d-flex justify-content-between">
        <div id="VehicleData">
          <VehicleData
            userId={this.props.match.params.id}
            vehicleId={this.props.match.params.vehicleId}
          />
        </div>
        <div id="Documents">
          <Documents
            userId={this.props.match.params.id}
            vehicleId={this.props.match.params.vehicleId}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/index.js